export const version = '1.18.1';
//# sourceMappingURL=version.js.map